/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ColumnDataset from './column';
import { stubFN, UNDEF } from '../lib/lib';
import { _checkPointerOverColumn } from '../misc/column3d-utils';
import { addDep } from '../dependency-manager';
import column3dAnimation from '../animation-rules/column3d-animation';

let createGroup = function (groupName, paper, parentContainer) {
  return paper.group(groupName, parentContainer);
};
addDep({
  name: 'column3dAnimation',
  type: 'animationRule',
  extension: column3dAnimation
});
/**
 * Creates class for Column3DDataset
 */
class Column3DDataset extends ColumnDataset {
  /**
   * Constructor function of Column3DDataset class to initiate
   */
  constructor () {
    super();
    this.setContainerVisibility = stubFN;
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'column3D';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.use3dlighting = UNDEF;
  }
  /**
   * function to create group for dataset
   */
  createContainer () {
    var dataset = this,
      parent = dataset.getLinkedParent(),
      paper = dataset.getFromEnv('paper');

    !dataset.getContainer('labelGroup') && dataset.addContainer('labelGroup',
      createGroup('label-group', paper, parent.getChildContainer('vcanvasLabelGroup'))
        .attr('class', 'fusioncharts-datalabels'))
      .attr('opacity', 1);
  }
  /**
   * Function that retunr the nearest plot details
   * @param {number} chartX x-axis position of the mouse cordinate
   * @param {number} chartY x-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest polt and whether it is hovered or not
   */
  _getHoveredPlot (chartX, chartY) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      isBar = chart.isBar,
      xAxis = dataset.getFromEnv('xAxis'),
      x,
      pX;

    x = xAxis.getValue(isBar ? chartY : chartX);
    pX = Math.round(x);
    // Checking for overlap between two cosecutive column plots along x-axis
    return (pX - x > 0 ? _checkPointerOverColumn.call(dataset, pX, chartX, chartY) ||
      _checkPointerOverColumn.call(dataset, pX - 1, chartX, chartY) :
      _checkPointerOverColumn.call(dataset, pX + 1, chartX, chartY) ||
      _checkPointerOverColumn.call(dataset, pX, chartX, chartY));
  }
}
export default Column3DDataset;
